<template>
  <div id="app">
    <AppConfirmDialog />

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <!-- Global ProductEditModal - Tüm sayfalarda kullanılabilir -->
    <product-edit-modal
      v-if="$store.state.productEditModalId !== null && $store.state.productEditModalId !== undefined"
      @saved="handleProductUpdate"
      @deleted="handleProductDelete"
    />

    <!-- Global ProductQuickEdit - Tüm sayfalarda kullanılabilir -->
    <product-quick-edit
      :productId="$store.state.asideProductQuickEditId"
      @product-quick-updated="handleProductUpdate"
    />

    <!-- Global ViewProductModal - Tüm sayfalarda kullanılabilir -->
    <view-product-modal
      :id.sync="$store.state.viewProductModalId"
    />

    <!-- Global ShoppingCartSidebar - Tüm sayfalarda kullanılabilir -->
    <shopping-cart-sidebar />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "App",
  data() {
    return {
      lastCartFirmId: null,
    };
  },
  computed: {
    ...mapState(["selectedFirm"]),
  },
  watch: {
    selectedFirm: {
      immediate: true,
      handler(newFirm) {
        const firmId = newFirm?.id;
        if (!firmId || firmId === this.lastCartFirmId) return;

        this.lastCartFirmId = firmId;
        this.initializeCart(firmId);
      },
    },
  },
  methods: {
    async initializeCart(firmId) {
      this.$store.dispatch("cart/setCurrentRestaurantId", firmId);
      try {
        await this.$store.dispatch("cart/loadCartFromBackend", firmId);
      } catch (error) {
        console.error("Failed to pre-load cart:", error);
      }
    },
    handleProductUpdate(product) {
      // Global product update event - Event bus ile tüm bileşenlere ilet
      this.$root.$emit("product-updated", product);
    },
    handleProductDelete(productId) {
      this.$root.$emit("product-deleted", productId);
    },
  },
};
</script>

<style lang="sass">
@import "assets/scss/style";
@import "~pretty-checkbox/src/pretty-checkbox.scss";
</style>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Interaktif alanlarda tarayiciya zoom yerine normal dokunma davranisi ipucu ver. */
button,
[role="button"],
a {
  touch-action: manipulation;
}

/* iOS Safari'de olasi caret kaybolmalarina karsi form alanlarinda caret rengini acikca koru. */
input,
textarea,
[contenteditable="true"],
[contenteditable=""] {
  -webkit-user-select: text;
  user-select: text;
  -webkit-text-fill-color: currentColor;
}

input,
textarea,
[contenteditable="true"],
[contenteditable=""] {
  caret-color: currentColor;
}
</style>
